fx.ns("filters", class TextTagFilter extends fx.Filter {

	constructor()
	{
        super();
    }

    get tagid()
    {
        return this._tagid;
    }

    set tagid(val)
    {
        this._tagid = val;
        this._changed = true;
        this.trigger("updated");
    }

    get productId()
    {
        return this._productId;
    }

    set productId(val)
    {
        this._productId = val;
        this._changed = true;
        this.trigger("updated");
    }

   
	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        
        //if (this.tagid)
        //{
            for (let i = 0; i < this.rawData.length; i++)
            {
                let text = this.rawData.getItemAt( [i] );

                if (text.theme_tag_id == this.tagid && fx.service("LangService").current.id == text.id_lang)
                    this.transformedData.push( text );
                else
                if (text.product_id == this.productId)
                    this.transformedData.push( text );
            }
        //}

		return this.transformedData;
	}	
});